const darkColors = {
  white: '#FFFFFF',
  blue: '#3773f5',
  darkGray: '#0A0B0D',
  gray: '#8A919E'
};
const darkTheme = {
  color: {
    background: darkColors.darkGray,
    border: `${darkColors.gray}20`,
    text: darkColors.white,
    textAccent: darkColors.blue,
    textAccentHover: darkColors.blue,
    textLight: darkColors.white,
    textHover: darkColors.blue,
    backgroundAlt: darkColors.darkGray,
    buttonFill: darkColors.blue,
    buttonFillHover: `${darkColors.blue}92`,
    buttonText: darkColors.darkGray,
    secondaryButtonFill: darkColors.darkGray,
    secondaryButtonFillHover: `${darkColors.darkGray}98`,
    secondaryButtonText: darkColors.white
  },
  logoKey: 'white'
};
export { darkTheme as default };
//# sourceMappingURL=darkTheme.js.map
